module.exports = __webpack_public_path__ + "img/AvogadroAmedeo.14da6bd0.jpg";